import { get_axios_file_instance, api_variables } from "@/apis/variables.js";

var axios_instance = get_axios_file_instance(api_variables.SERVICE_FORM16_UPLOAD);
var axios_instance_get_from_16 = get_axios_file_instance(api_variables.SERVICE_LIST_FROM16);
//const _pk_name = "id";


const actions = {
  async create({ commit }, payload) {
    //console.log("[state/payroll/form16/create] Adding...", payload);
    try {
      // commit("setSaving", true);
      let res = await axios_instance.post("/", payload);
      // commit("setSaving", false);
      //console.log("[state/payroll/form16/create] res: ", res);
      if (res.status == 200) {
        // commit("addEmployee", payload);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async getForm16({ commit }, payload) {
    try {
        let res = await axios_instance_get_from_16.get('/', {
            params: {
              le_id:payload
            }
          });
        if (res) {
           
           return res;
        }
    } catch (error) {
        //return res;
        return  error;
        
        }
    },

};

export default {
  namespaced: true,
  actions
};
